import { render, staticRenderFns } from "./CompactEvent.vue?vue&type=template&id=960a9c2e&scoped=true&"
import script from "./CompactEvent.vue?vue&type=script&lang=js&"
export * from "./CompactEvent.vue?vue&type=script&lang=js&"
import style0 from "./CompactEvent.vue?vue&type=style&index=0&id=960a9c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960a9c2e",
  null
  
)

export default component.exports